'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_MESSAGE_TO_STUBBED_CHANNEL = exports.ADD_MESSAGE_TO_STUBBED_CHANNEL = 'ADD_MESSAGE_TO_STUBBED_CHANNEL';

var RESET_STUBBED_CHANNEL = exports.RESET_STUBBED_CHANNEL = 'RESET_STUBBED_CHANNEL';


//////////////////
// WEBPACK FOOTER
// ./js/stubbed-thread-history/constants/StubbedThreadHistoryActionTypes.js
// module id = 90
// module chunks = 2 3